<template>
  <span class="oido-icon test" :class="{ [name]: true, 'primary': primary, 'disabled': disabled }" v-html="svg"></span>
</template>


<script>
import icons from './icons'

export default {
  props: {
    name: String,
    stroke: String,
    strokeWidth: String,
    size: String,
    primary: Boolean,
    disabled: Boolean
  },
  computed: {
    svg() {
      let svg = null
      if (icons[this.name]) {
        svg = icons[this.name]
      }
      if (svg) {
        let styles = ''
        if (this.stroke) {
          styles += `stroke: ${this.stroke}!important;`
        }
        if (this.size) {
          styles += `width: ${this.size}!important;`
        }
        if (this.strokeWidth) {
          styles += `stroke-width: ${this.strokeWidth}!important;`
        }
        svg = svg.replace('<svg ', `<svg style="${styles}" `)
      }
      return svg
    }

  }
}

</script>


<style scoped></style>
<style>
.oido-icon svg {
  stroke: black;
  fill: transparent;
  stroke-width: 50px;
}


.oido-icon.clock-outgoing svg,
.oido-icon.clock-incoming svg {
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
  stroke-width: 1px;
  fill: inherit;
}

.oido-icon.delivery-time svg {
  width: 28.8867px !important;
  height: 21.8066px !important;
  font-size: 1rem;
  stroke-width: 0.5px;
  fill: inherit;
  zoom: 0.75;
}

.oido-icon.alert svg,
.oido-icon.alert svg *,
.oido-icon.warning svg *,
.oido-icon.warning svg {
  stroke: transparent !important;
  stroke-width: 0 !important;
  fill: white !important;
  ;

}


.oido-icon.numbered-list svg,
.oido-icon.bullet-list svg,
.oido-icon.add-note svg,
.oido-icon.sad svg,
.oido-icon.qrcode-doc svg,
.oido-icon.note svg {
  stroke: transparent;
  stroke-width: 0px;
}

.oido-icon.numbered-list svg *,
.oido-icon.bullet-list svg *,
.oido-icon.add-note svg *,
.oido-icon.note svg * ,
.oido-icon.qrcode-doc svg * {
  stroke-width: 0px !important;
  fill: var(--ion-color-medium) !important;
}


.oido-icon.primary:not(.disabled) svg * {
  stroke: var(--ion-color-primary) !important;
  fill: var(--ion-color-primary) !important;
}

.oido-icon.primary:not(.disabled) svg * {}

.oido-icon.disabled.test svg *,
.oido-icon.primary.disabled.test svg * {
  stroke: var(--ion-color-light) !important;
  fill: var(--ion-color-light) !important;
  stroke: #bbb !important;
  fill: #bbb !important;

}
.oido-icon.download.test:not(.madupclass) svg *,
.oido-icon.edit.test:not(.madupclass) svg * {
  fill: transparent !important;
}
</style>
